<template>
  <div class="form-category-multi-check">
    <kt-autoselect
      :label="props.label"
      :options="categoryOptions"
      display-by="label"
      value-by="value"
      :multiple="true"
      v-model="model"
      search-placeholder="Search categories..."
      :on-refresh="handleRefresh"
      @change="handleChange"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import KtAutoselect from '@/components/UI/KtAutoselect.vue';
import Api from '@/services/ApiService';

const props = defineProps({
  label: { 
    type: String, 
    default: 'Category' 
  }
});

const emit = defineEmits<{
  change: [value: string[]];
}>();

const model = defineModel<string[]>({
  default: () => []
});

const categoryOptions = ref<{ label: string; value: string }[]>([]);

const loadCategories = async () => {
  try {
    const response = await Api.loadFormTemplates({ Size: 1000 }, true);
    const cats = new Set<string>();
    (response.Data || []).forEach((template: any) => {
      if (template.Category) cats.add(template.Category);
    });
    categoryOptions.value = Array.from(cats).sort().map(cat => ({
      label: cat,
      value: cat
    }));
  } catch (error) {
    console.error('Failed to load categories:', error);
    categoryOptions.value = [];
  }
};

onMounted(async () => {
  await loadCategories();
});

const handleChange = (value: string[]) => {
  emit('change', value);
};

const handleRefresh = async () => {
  await loadCategories();
};
</script>
